import getJwtTokenProvider from '../../features/login/jwt-token-provider';
import getAuth0 from './client';

export async function generateAccessToken(opt) {
  try {
    const auth0 = await getAuth0();
    return await auth0.getTokenSilently(opt);
  } catch (err) {
    return null;
  }
}

let accessToken;

export async function refreshAccessToken(opt) {
  const jwtTokenProvider = getJwtTokenProvider();

  if (!jwtTokenProvider.token || jwtTokenProvider.isSilentRefreshReady) {
    accessToken = await generateAccessToken(opt);

    jwtTokenProvider.setToken(accessToken);
  } else {
    accessToken = jwtTokenProvider.token;
  }

  return accessToken;
}

export function isAccessTokenExpired() {
  return getJwtTokenProvider().isExpired;
}



// WEBPACK FOOTER //
// ./src/utils/auth0/access-token.js